import { useState, useEffect } from 'react';
import { mapConfig } from '../components/map/utils/mapConfig';

interface Location {
  lat: number;
  lng: number;
}

export const useGeolocation = () => {
  const [location, setLocation] = useState<Location | null>(null);
  const [geolocationAllowed, setGeolocationAllowed] = useState(true);

  useEffect(() => {
    if (!navigator.geolocation) {
      setGeolocationAllowed(false);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        console.error('Error getting location:', error);
        if (error.code === error.PERMISSION_DENIED) {
          setGeolocationAllowed(false);
        }
        setLocation({
          lat: mapConfig.defaultCenter[0],
          lng: mapConfig.defaultCenter[1],
        });
      }
    );
  }, []);

  return { location, setLocation, geolocationAllowed };
};